/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

//Standard libraries
import { AxiosPromise } from "axios";
//Foundation libraries
import { getSite } from "../../hooks/useSite";
import { EventApi } from "@hcl-commerce-store-sdk/typescript-axios-transaction";
import { site } from "../../constants/site";

const eventApiInstance = new EventApi(undefined, site.transactionContext);

const marketingService = {
  /**
   * This method returns a list of enabled store features.
   * `@method`
   * `@name Store#getStoreEnabledFeaturesList`
   *
   * `@param {any} parameters` have following properties:
   ** `@property {string} storeId (required)` The child property of `Parameters`.The store identifier.
   */

  marketingEvent(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;

    return eventApiInstance.eventTriggerMarketing(storeId, undefined, body, options);
  },
};

export default marketingService;
